<div *ngIf="!show" class="button-container">
    <div class="button">
        <button (click)="show = true"  mat-fab style=" color: gray; border:1px solid gray;  background-color: white" automation-id="play-button-onboarding-video">
          <mat-icon >play_arrow</mat-icon>
        </button>
     </div>
      <div class="label">
        <label>
            Need Help? Watch this tutorial that walks you through a step-by-step process on adding your staff.
        </label>
      </div>
</div>


<div *ngIf="show" class="video-container">

      <div class="frame-style">
        <iframe 
        [src]="videoUrl | safe: 'resourceUrl'"
        frameborder="0" 
        allowfullscreen
        width="600px"
        height="340px"
        ></iframe>
      </div>
      <span (click)="show = false" class="close">
        <!-- <mat-icon >close</mat-icon> -->
        Close
      </span>

</div>